"use strict";

exports.__esModule = true;
exports["default"] = exports.PanelImage = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _utils = require("../../utils");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _panelText = _interopRequireDefault(require("../panel-text"));

var _excluded = ["alignItems", "children", "description", "descriptionFont", "headingLevel", "imageAbove", "imageSpacing", "imageBelow", "justifyContent", "pretitle", "pretitleFont", "subtitle", "subtitleFont", "title", "titleFont", "titleRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PanelImage = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "panel-content__PanelImage",
  componentId: "sc-14qr6kl-0"
})(["max-width:100%;"]);
exports.PanelImage = PanelImage;
var propTypes = {
  /** The direction that the text should align in the PanelText */
  alignItems: _propTypes.string,

  /** Children, a node or can be a React component */
  children: _propTypes.node,

  /** Description usually a text string but can be a node */
  description: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Object with font and spacing setting for the description */
  descriptionFont: _utils.fontPropType,

  /** string for heading level */
  headingLevel: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /** The source of an image to display at the top of the header content */
  imageAbove: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** The source of an image to display below the header content */
  imageBelow: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Image Spacing */
  imageSpacing: _utils.stylePropType,

  /** Justify, a string  which represents the content centers between the left and right edges. */
  justifyContent: _propTypes.string,

  /** Pretitle, usually a text string but can be a node */
  pretitle: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Object with font and spacing setting for the pretitle */
  pretitleFont: _utils.fontPropType,

  /** Subtitle, usually a text string */
  subtitle: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.func, _propTypes.node, _propTypes.string]),

  /** Object with font and spacing setting for the subtitle */
  subtitleFont: _utils.fontPropType,

  /** Title, usually a text string, but can be a node */
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),

  /** Object with fontPropType and spacing setting for the title */
  titleFont: _utils.fontPropType,

  /** Title ref function */
  titleRef: _propTypes.func
};
var defaultProps = {
  imageSpacing: 2
};
/**
 * A Panel of Content, which is an array of either PanelTexts or Image nodes
 */

var PanelContent = function PanelContent(_ref) {
  var alignItems = _ref.alignItems,
      children = _ref.children,
      description = _ref.description,
      descriptionFont = _ref.descriptionFont,
      headingLevel = _ref.headingLevel,
      imageAbove = _ref.imageAbove,
      imageSpacing = _ref.imageSpacing,
      imageBelow = _ref.imageBelow,
      justifyContent = _ref.justifyContent,
      pretitle = _ref.pretitle,
      pretitleFont = _ref.pretitleFont,
      subtitle = _ref.subtitle,
      subtitleFont = _ref.subtitleFont,
      title = _ref.title,
      titleFont = _ref.titleFont,
      titleRef = _ref.titleRef,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    alignItems: alignItems,
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: justifyContent,
    width: 1
  }, props), imageAbove && ((0, _ramda.is)(String, imageAbove) ? /*#__PURE__*/_react["default"].createElement(PanelImage, {
    mb: imageSpacing,
    src: imageAbove
  }) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mb: imageSpacing
  }, imageAbove)), (title || subtitle || description) && /*#__PURE__*/_react["default"].createElement(_panelText["default"], {
    description: description,
    descriptionFont: descriptionFont,
    headingLevel: headingLevel,
    pretitle: pretitle,
    pretitleFont: pretitleFont,
    subtitle: subtitle,
    subtitleFont: subtitleFont,
    textAlign: alignItems,
    title: title,
    titleFont: titleFont,
    titleRef: titleRef
  }), imageBelow && ((0, _ramda.is)(String, imageBelow) ? /*#__PURE__*/_react["default"].createElement(PanelImage, {
    mt: imageSpacing,
    src: imageBelow
  }) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    mt: imageSpacing
  }, imageBelow)), children);
};

PanelContent.propTypes = propTypes;
PanelContent.defaultProps = defaultProps;
PanelContent.displayName = "Modules.PanelContent";
var _default = PanelContent;
exports["default"] = _default;